import FleetGroupedTransformer from "@/transformers/FleetGroupedTransformer";
import CollectionTransformer from "@/transformers/CollectionTransformer";
import FleetStatisticsTransformer from "@/transformers/FleetStatisticsTransformer";
import OrganizationTransformer from "@/transformers/OrganizationTransformer";
import DeviceTransformer from "@/transformers/DeviceTransformer";
import MediaTransformer from "@/transformers/MediaTransformer";
import {FleetTransformer} from "@/transformers/FleetTransformer";
import UserTransformer from "@/transformers/UserTransformer";
import EventTransformer from "@/transformers/EventTransformer";
import VehicleTransformer from "@/transformers/VehicleTransformer";
import {JourneysTransformer} from "@/transformers/JourneysTransformer";
import {DeviceEventShareTransformer} from "@/transformers/DeviceEventShareTransformer";

export {
    FleetGroupedTransformer,
    CollectionTransformer,
    FleetStatisticsTransformer,
    OrganizationTransformer,
    DeviceTransformer,
    MediaTransformer,
    FleetTransformer,
    VehicleTransformer,
    UserTransformer,
    EventTransformer,
    JourneysTransformer,
    DeviceEventShareTransformer
}

const transformers = {
    collectionTransformer: new CollectionTransformer(),
    fleetGroupedTransformer: new FleetGroupedTransformer(),
    feetStatisticsTransformer: new FleetStatisticsTransformer(),
    organizationTransformer: new OrganizationTransformer(),
    deviceTransformer: new DeviceTransformer(),
    mediaTransformer: new MediaTransformer(),
    fleetTransformer: new FleetTransformer(),
    vehicleTransformer: new VehicleTransformer(),
    userTransformer: new UserTransformer(),
    eventTransformer: new EventTransformer(),
    journeysTransformer: new JourneysTransformer(),
    deviceEventShareTransformer: new DeviceEventShareTransformer()
}

export default transformers
